import { createAction } from "@ngrx/store";
import { createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { Game, GameDetail } from "./game.model";

export const ACTION_PREFIX = "[Game]";

export namespace GameAction {
	export const fetchAll = createAction(`${ACTION_PREFIX} Fetch All`, (provider?: string) => ({ provider }));

	export const fetchAllSuccess = createGetSuccessAction(
		createAction(`${ACTION_PREFIX} Fetch All Success`, (games: Record<string, Game>) => ({ games }))
	);

	export const fetchAllFail = createAction(`${ACTION_PREFIX} Fetch All Fail`, (error: AppError) => ({ error }));

	export const getAll = createCachedGetAction(fetchAll);

	export const getDetail = createAction(`${ACTION_PREFIX} Get Detail`, (gameId: string) => ({ gameId }));

	export const getDetailSuccess = createAction(`${ACTION_PREFIX} Get Detail Success`, (gameDetail: GameDetail) => ({
		gameDetail,
	}));

	export const getDetailFail = createAction(`${ACTION_PREFIX} Get Detail Fail`, (error: AppError) => ({ error }));

	export const fetchByCollectionId = createAction(
		`${ACTION_PREFIX} Fetch By Collection Id`,
		(collectionId: string, topCount = 20) => ({ collectionId, topCount })
	);

	export const fetchByCollectionIdSuccess = createGetSuccessAction(
		createAction(`${ACTION_PREFIX} Fetch By Collection Id Success`, (games: Record<string, Game>) => ({ games }))
	);

	export const fetchByCollectionIdFail = createAction(
		`${ACTION_PREFIX} Fetch By Collection Id Fail`,
		(error: AppError) => ({ error })
	);

	export const getByCollectionId = createCachedGetAction(fetchByCollectionId);

	export const getGames = createAction(`${ACTION_PREFIX} Get Games`, (collectionId?: string) => ({ collectionId }));

	export const getGamesByGameIds = createAction(`${ACTION_PREFIX} Get Games By GameIds`, (gameIds: string[]) => ({
		gameIds,
	}));

	export const getGamesByGameIdsSuccess = createAction(
		`${ACTION_PREFIX} Get Games By GameIds Success`,
		(games: Record<string, Game>) => ({ games })
	);

	export const getGamesByGameIdsFail = createAction(
		`${ACTION_PREFIX} Get Games By GameIds Fail`,
		(error: AppError) => ({ error })
	);
}
